$(document).ready(function () {

  function initSliders() {
    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });
  }

  function destroySliders() {
    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      if ($(slider).hasClass('slick-initialized')) {
        $(slider).slick('unslick');
      }
    });
  }

  // init on load
  initSliders();

  // re-init on resize (debounced)
  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      destroySliders();
      initSliders();
    }, 300); // debounce
  });

});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('#top-pick').scrollIntoView({
    behavior: 'smooth'
  })
});
